export default __webpack_public_path__ + "static/media/contracts.90a62d92.jpg";